import { Box, Button, List, ListItem } from '@mui/material';
import { LineItem } from 'components';
import { useAlerts } from 'hooks';

const AcademyDetails = ({ academy, regenerateInvitationCode }) => {
	const { showAlertSuccess } = useAlerts();
	const handleCopyToClipboard = () => {
		navigator.clipboard.writeText(academy.invitation_code);
		showAlertSuccess('Invitation code copied to clipboard');
	};

	return (
		<List>
			<ListItem>
				<img src={academy.image_url} width={240} />
			</ListItem>

			<LineItem label="Title" value={academy.title} />
			<LineItem label="Description" value={academy.description} />
			<LineItem label="partner name" value={academy.partner_name} />
			<LineItem label="partner Email" value={academy.partner_email} />
			<Box>
				<LineItem
					label="Invitation Code"
					value={academy.invitation_code}
					onClick={handleCopyToClipboard}
				/>
				<Button
					variant="contained"
					color="primary"
					onClick={regenerateInvitationCode}
				>
					Regenerate Code
				</Button>
			</Box>
		</List>
	);
};

export default AcademyDetails;
